export default function StormwaterEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/stormwater/2026_MS4_Program_Updates.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2026 MS4 Program Updates
          </a>
        </td>
        <td>07/08/2026</td>
        </tr>
        {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/stormwater/stormwater-mgmt-info.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Stormwater Management Education
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
